import React, { useEffect } from 'react'
import Navbar from '../HomePage/Navbar'
import ContactSection from '../HomePage/ContactSection'
import NewsLetter from '../HomePage/NewsLetter'
import Footer from '../HomePage/Footer'
import BlogsCards from './BlogsCards'

function BlogsIndex() {
  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Navbar />
      <BlogsCards />
      <ContactSection />
      <NewsLetter />
      <Footer />
    </div>
  )
}

export default BlogsIndex
